<div class="menuWrapper">
    @for (item of menuItems; track $index) {
    <div class="menuItemWrapper" (click)="menuItemClick(item, $event)"
        [ngClass]="{ selected: showMenuDrawer() && selectedMenuItem() == item }">
        <span>{{ item.name }}</span>
        <span class="material-symbols-outlined">
            expand_more
        </span>

    </div>
    }
</div>

@if (showMenuDrawer()) {
<div class="menuDrawer">
    @for (item of selectedMenuItem().children; track $index) {
    <div class="group">
        <h3 style="padding-bottom: 8px;">{{ item.name }}</h3>
        <mat-divider></mat-divider>
        @for (child of item.children; track $index) {
        <div class="childItem" (click)="navigate(child, $event)">
            <div class="material-symbols-outlined">
                chevron_right
            </div>
            <span>{{ child.name }}</span>
        </div>
        }
    </div>
    }
</div>
}